import { LanguageCode } from '../../enums/language-service.enum';

export class BaiduLanguageDictionary {

  public language = [
    { code: LanguageCode.zh, name: 'ä¸­æ' },
  ];

}
